import React from "react";
import { motion } from "framer-motion";
import { FaCode, FaMapMarkerAlt, FaCalendarAlt, FaUserCheck } from "react-icons/fa";

const AboutMe = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={{
        visible: { transition: { staggerChildren: 0.2 } }
      }}
      className="bg-gray-800 rounded-xl shadow-xl overflow-hidden border border-gray-700"
    >
      <div className="flex flex-col lg:flex-row">
        {/* Левая часть */}
        <motion.div
          variants={fadeIn}
          className="w-full lg:w-1/2 p-8 lg:p-10 border-b lg:border-b-0 lg:border-r border-gray-700"
        >
          <div className="flex items-start mb-6">
            <div className="bg-blue-500 p-3 rounded-lg mr-4">
              <FaCode className="text-xl text-white" />
            </div>
            <div>
              <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent mb-2">
                Привет, я Даниил Васильев
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Full-Stack разработчик из Казахстана, Костанай. Специализируюсь на современных веб-технологиях,
                включая JavaScript, React и Node.js.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Правая часть */}
        <motion.div
          variants={fadeIn}
          className="w-full lg:w-1/2 p-8 lg:p-10"
        >
          <ul className="space-y-5">
            <motion.li
              whileHover={{ x: 5 }}
              className="flex items-center p-4 bg-gray-700 rounded-lg hover:bg-gray-600 transition-colors"
            >
              <div className="bg-blue-500 p-2 rounded-lg mr-4">
                <FaCalendarAlt className="text-lg text-white" />
              </div>
              <div>
                <span className="block text-sm text-gray-400">Возраст:</span>
                <span className="text-lg font-medium text-white">20 лет</span>
              </div>
            </motion.li>

            <motion.li
              whileHover={{ x: 5 }}
              className="flex items-center p-4 bg-gray-700 rounded-lg hover:bg-gray-600 transition-colors"
            >
              <div className="bg-purple-500 p-2 rounded-lg mr-4">
                <FaMapMarkerAlt className="text-lg text-white" />
              </div>
              <div>
                <span className="block text-sm text-gray-400">Локация:</span>
                <span className="text-lg font-medium text-white">Казахстан, Костанай</span>
              </div>
            </motion.li>

            <motion.li
              whileHover={{ x: 5 }}
              className="flex items-center p-4 bg-gray-700 rounded-lg hover:bg-gray-600 transition-colors"
            >
              <div className="bg-blue-500 p-2 rounded-lg mr-4">
                <FaUserCheck className="text-lg text-white" />
              </div>
              <div>
                <span className="block text-sm text-gray-400">Статус:</span>
                <span className="text-lg font-medium text-green-400">Доступен для работы</span>
              </div>
            </motion.li>
          </ul>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AboutMe;